import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/currentCancelInfo', request)
}

export {get}
